<template>
    <div class="right-container">
        <p class="right-h2">其他</p>
        <p class="right-h3">loading</p>
        <p class="right-content">不管是小程序还是Vue项目我们都会去请求网络，而网络请求是需要时间，这个时间也许很短，也有可能因为网络阻塞导致变长，这个时候我们就需要在网络请求的过程中加上loading来告诉用户现在正在请求网络中，以便起到引导用户的作用。</p>
        <p class="right-content">Vue项目可以使用element组件里面的loading组件。</p>
        <div class="right-code">
            <pre>
                <code class="language-markup line-numbers" v-html="code.other.other1"></code>
            </pre>
        </div>
        <p class="right-content">小程序项目可以使用小程序自带的showLoading()API。</p>
        <p class="right-content">以微信小程序为例：</p>
        <div class="right-code">
            <pre>
                <code class="language-js line-numbers" v-html="code.other.other2"></code>
            </pre>
        </div>
    </div>
</template>

<script>
import code from '../../utils/code'
import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
export default {
    name: 'other',
    data () {
        return {
            code: code
        }
    },
    mounted () {
        Prism.highlightAll()
    }
}
</script>

<style lang="scss" scoped>

</style>